<template>
  <div class="z_FloatBtn_vue">
    <div class="z_float_btn">
      <!-- <div @click="opinion" class="z_btn z_btn1">
        <svg-icon className="z_nav_icon" icon-class="nav_float1" />
        <span>意见建议</span>
      </div> -->


      <div class="z_btn z_btn0" @mouseenter="imgView" @mouseleave="imgClose">
          <img style="height: 40px;margin-top: 15px;" src="../../assets/xcxicon.png" />
          <span style="color: #595959;">微信小程序</span>
          <span v-show="imgshow" style="position: absolute;height: 205px;right: 105px;margin-top: -87px;">
            <img style="height: 205px;" src="../../assets/xcx2wm.jpg">
            <span v-if="imgshow" style="width: 205px;font-size: 18px;color: black;font-weight: bold;margin-top: 15px;">甬采汇 (扫码查看)</span>
          </span>
      </div>
      <div class="z_btn z_btn1">
        <a href="https://ygcg.nbcqjy.org:8071/page/register/registagreement.html" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_float6" />
          <span>会员注册</span>
        </a>
      </div>
      <div class="z_btn z_btn4">
        <a href="https://ygcg.nbcqjy.org:8071/login.html?systemName=%E5%8D%95%E4%BD%8D%E4%BF%A1%E6%81%AF%E7%AE%A1%E7%90%86" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_float7" />
          <span>会员管理</span>
        </a>
      </div>
      <div class="z_btn z_btn3">
        <a href="https://ygcg.nbcqjy.org:8073/" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_float4" />
          <span>开标直播</span>
        </a>
      </div>
      <div class="z_btn z_btn2">
        <a href="http://ygcg.nbcqjy.org:8066" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_float8" />
          <span>网上评标</span>
        </a>
      </div>
      <div class="z_btn z_btn2">
        <a href="http://tseal.cn/tcloud/common.xhtml?projId=254" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_float9" />
          <span>CA办理</span>
        </a>
      </div>
      <div class="z_btn z_btn5">
        <a href="https://ygcg.nbcqjy.org/detail?articleId=461" target="_blank">
          <svg-icon className="z_nav_icon" icon-class="nav_header8" />
          <span>工具下载</span>
        </a>
      </div>

      <!-- 微信 -->
      <!-- <div class="z_wx_hover">
        <div class="z_btn z_btn5">
          <svg-icon className="z_nav_icon" icon-class="nav_float2" />
          <span>官方微信</span>
        </div>
        <div class="z_wx">
          <img src="../../assets/WXQR.png" />
        </div>
      </div> -->
    </div>
    <a-modal
      title="意见反馈"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="提交"
      cancelText="取消"
    >
      <a-form-model
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="form"
      >
        <a-form-model-item label="尊姓大名" prop="name">
          <a-input placeholder="匿名可不填" v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="tel">
          <a-input placeholder="您的邮箱或者电话（选填）" v-model="form.tel" />
        </a-form-model-item>
        <a-form-model-item label="反馈网址" prop="url">
          <a-input placeholder="问题网址（选填）" v-model="form.url" />
        </a-form-model-item>
        <a-form-model-item
          :rules="{
            required: true,
            message: '请输入意见留言',
          }"
          label="意见留言"
          prop="content"
        >
          <a-input
            placeholder="请写下您的宝贵意见吧。。。"
            v-model="form.content"
            type="textarea"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { AddOpinion } from "@/api/protal";
export default {
  components: {},
  data() {
    return {
      imgshow:false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      visible: false,
      confirmLoading: false,
      form: {
        name: "",
        tel: "",
        url: "",
        content: "",
      },
    };
  },
  methods: {
    imgView(){
      this.imgshow = true;
    },
    imgClose(){
      this.imgshow = false;
    },
    opinion() {
      this.visible = true;
    },
    handleOk() {
      this.confirmLoading = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          AddOpinion(this.form).then((res) => {
            if (res) {
              this.confirmLoading = false;
              this.$refs.ruleForm.resetFields();
              this.$message.success("提交成功，感谢您的宝贵意见！");
              this.visible = false;
            }
          });
        } else {
          this.confirmLoading = false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>
<style lang="less">
// .z_FloatBtn_vue{
//   .z_float_btn {
//     position: fixed;
//     right: 16px;
//     bottom: 128px;
//     width: 64px;
//     height: 320px;
//     // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
//     box-shadow: 0 2px 6px -4px rgba(0, 0, 0, 0.09),
//       0 4px 10px 0 rgba(0, 0, 0, 0.06), 0 6px 16px 6px rgba(0, 0, 0, 0.03);
//     border-radius: 4px;
//     z-index: 1000;
//     .z_btn {
//       width: 64px;
//       height: 64px;
//       border-bottom: 1px solid rgba(0, 0, 0, 0.09);
//       text-align: center;
//       cursor: pointer;
//       background: rgba(255, 255, 255, 0.82);
//       -webkit-backdrop-filter: saturate(180%) blur(20px);
//       backdrop-filter: saturate(180%) blur(20px);
//       .z_nav_icon {
//         width: 24px;
//         height: 24px;
//         color: #595959;
//         fill: #595959;
//         margin-top: 10px;
//       }
//       span {
//         font-size: 12px;
//         color: #595959;
//         display: block;
//         text-align: center;
//       }
//     }

//     .z_btn:hover {
//       color: #ff4d4f;
//       span {
//         color: #ff4d4f;
//       }
//       .z_nav_icon {
//         color: #ff4d4f;
//         fill: #ff4d4f;
//       }
//     }

//     .z_btn1 {
//       border-radius: 4px 4px 0 0;
//       overflow: hidden;
//       .z_nav_icon {
//         color: #ff4d4f;
//         fill: #ff4d4f;
//       }
//     }

//     .z_btn5 {
//       border-radius: 0 0 4px 4px;
//       border-bottom: 0;
//       .z_nav_icon {
//         color: #0ab955;
//         fill: #0ab955;
//       }
//     }
//     .z_btn5:hover {
//       .z_nav_icon {
//         color: #52c41a;
//         fill: #52c41a;
//       }
//       span {
//         color: #52c41a;
//       }
//     }
//   }

//   @media screen and (max-width: 1400px){
//     .z_float_btn{
//       right: 0;
//           .z_btn1 {
//         border-radius: 4px 0 0 0;
//       }
//       .z_btn5 {
//         border-radius: 0 0 0 4px;
//       }
//     }
//   }
//   .z_wx {
//     position: fixed;
//     width: 128px;
//     height: 128px;
//     right: 84px;
//     bottom: 128px;
//     z-index: 1000;
//     box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
//     box-shadow: -3px 2px 6px -4px rgba(0, 0, 0, 0.09),
//       -4px 2px 16px 0 rgba(0, 0, 0, 0.06), -6px 3px 24px 8px rgba(0, 0, 0, 0.04);
//     border-radius: 4px;
//     background: rgba(255, 255, 255, 0.82);
//     -webkit-backdrop-filter: saturate(180%) blur(20px);
//     backdrop-filter: saturate(180%) blur(20px);
//     display: none;
//     transition: all 0.3s;
//     overflow: hidden;
//     padding: 4px;
//     img {
//       width: 120px;
//       height: 120px;
//     }
//   }
//   .z_wx_hover:hover {
//     .z_wx {
//       display: block;
//     }
//   }

//   // 主题按钮
//   .ant-btn:hover, .ant-btn:focus {
//       color: #ff4d4f;
//       background-color: #fff;
//       border-color: #ff4d4f;
//   }
//   .ant-btn:active, .ant-btn.active {
//       color: #cf1322;
//       background-color: #fff;
//       border-color: #cf1322;
//   }

//   .ant-btn-primary {
//       color: #fff;
//       background-color: #f5222d;
//       border-color: #f5222d;
//       text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
//       box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
//   }
//   .ant-btn-primary:hover, .ant-btn-primary:focus {
//       color: #fff;
//       background-color: #ff4d4f;
//       border-color: #ff4d4f;
//   }
//   .ant-btn-primary:active, .ant-btn-primary.active {
//       color: #fff;
//       background-color: #cf1322;
//       border-color: #cf1322;
//   }
// }
</style>